(function () {
    'use strict';

    angular
        .module('recommendationModule')
        .controller('grcRecommendationEditModalController', Controller);

    Controller.$inject = ['$scope', 'grcRecommendationService'];

    function Controller($scope, grcRecommendationService) {

        $scope.ctrlCtxt = {
            isUserSelectModalDisplayed: false
        };

        // On Select User Modal Open
        $scope.onOpenSelectUser = function () {
            $scope.ctrlCtxt.isUserSelectModalDisplayed = true;
        };

        // On Select User Modal Closed
        $scope.onSelectUserClosed = function () {
            $scope.ctrlCtxt.isUserSelectModalDisplayed = false;
        };

        // Add owner
        $scope.addOwner = function (owner) {
            if (_.isUndefined($scope.recommendation.OwnerList)) $scope.recommendation.OwnerList = [];

            $scope.recommendation.OwnerList.push(owner);
        };

        // Remove owner
        $scope.removeOwner = function (owner) {
            $scope.recommendation.OwnerList = _.reject($scope.recommendation.OwnerList, { ItemPersonID: owner.ItemPersonID });
        };

        // Select Owner Delegate
        $scope.selectOwnerDelegate = function (person) {
            $scope.recommendation.OwnerDelegate = person;
            $scope.recommendation.OwnerDelegateID = person.ItemPersonID;
        };

        // Remove Owner Delegate
        $scope.removeOwnerDelegate = function () {
            delete $scope.recommendation.OwnerDelegate;
            $scope.recommendation.OwnerDelegateID = null;
        };

        // Cancel Modal
        $scope.cancel = function () {
            $scope.close();
        };

        // Update Recommendation
        $scope.updateRecommendation = function () {
            grcRecommendationService
                .updateRecommendation($scope.recommendation)
                .then(function (updatedRecommendation) {
                    $scope.onSave();
                });
        };

    }
})();
